//place here your custom javascript, you're free to create all the js files you need

async function addToCart(variant, quantity = 1, contextElement) {
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

  return fetch(`${Shopify.routes.root}cart/add.js`, {
    body: JSON.stringify({
      items: [{
        id: variant,
        quantity: quantity
      }],
      sections: sectionsToBundle.join(",")
    }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then(async (response) => {
    const responseMessage = await response.json();
    if(!response.ok) {
      throw new Error((responseMessage.message || responseMessage.description));
    }
    return responseMessage;
  }).then(async data => {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent["sections"] = data["sections"];
    document.dispatchEvent(new CustomEvent("variant:add", {
      bubbles: true,
      detail: {
        items: data.hasOwnProperty("items") ? data["items"] : [data],
        cart: cartContent
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "variant:add",
        cart: cartContent
      }
    }));
  }).catch((error) => {
    if(contextElement){
      const alertElement = contextElement.querySelector('.banner.banner--error');
      if (alertElement) {
        const temporaryAlert = alertElement.cloneNode(true);
        temporaryAlert.innerHTML = error;
        alertElement.after(temporaryAlert);
        temporaryAlert.classList.remove('hidden');

        setTimeout(() => {
          temporaryAlert.remove();
        }, 3000);
      }
    }else{
      console.error(error)
    }
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
}

function getAvailableVariant(productItem, selectedSizeVariants) {
  const selectedColorVariants = productItem.querySelector('input[data-available-variants]:checked')?.getAttribute('data-available-variants')?.split(',') || [];

  return (selectedColorVariants.find(v => selectedSizeVariants.includes(v)) || false);
}

function addToCartFromProductItem() {
  document.querySelectorAll('[data-quick-buy]:not(.product-card--connected)').forEach((productItem) => {
    productItem.classList.add('product-card--connected');
    const sizeButtons = productItem.querySelectorAll('.product-card__size-badge[data-available-variants]');

    sizeButtons.forEach((sizeButton)=>{
      sizeButton.addEventListener('click', (e) => {
        e.preventDefault();
        const availableVariant = getAvailableVariant(productItem, (e.target.getAttribute('data-available-variants')?.split(',') || []));
        if (availableVariant) {
          addToCart(parseInt(availableVariant), 1, productItem);
        } else {
          const alertElement = productItem.querySelector('.banner.banner--error');
          if (alertElement) {
            alertElement.classList.remove('hidden');

            setTimeout(() => {
              alertElement.classList.add('hidden');
            }, 3000);
          }
        }
      });
    });

    const variantAlterators = productItem.querySelectorAll('.product-card__info [type="radio"][data-available-variants]');
    function disableUnvailableSizes(currentColor){
      sizeButtons.forEach((sizeButton) => {
        const isAvailableSize = 
          sizeButton.getAttribute('data-available-variants')?.split(',').find((sizeVariant) => {
            return currentColor.getAttribute('data-available-variants')?.split(',').includes(sizeVariant) || false;
          }) || false;

        isAvailableSize ? sizeButton.removeAttribute('disabled') : sizeButton.setAttribute('disabled', 'disabled');
      })
    }

    if(variantAlterators){
      disableUnvailableSizes(variantAlterators[0]);
    }

    variantAlterators.forEach((variantAlterator) => {
      variantAlterator.addEventListener('change', (e) => {
        if(e.target.checked){
          disableUnvailableSizes(e.target);
        }
      });
    });
  });
}

//-------------START Scroll To Top Element-------------------

function scrollToTop(){

  function bindScrollToTopVisibility(scrollToTopElement){
    document.addEventListener('scroll', (e)=>{
      if(window.scrollY > 1000){
        scrollToTopElement.classList.remove('ScrollToTop--hidden');
      }else{
        scrollToTopElement.classList.add('ScrollToTop--hidden');
      }
    })
  }

  function init(){
    let scrollToTopElement = document.querySelector('.ScrollToTop');

    if(scrollToTopElement){
      bindScrollToTopVisibility(scrollToTopElement);
    }
  }

  init()
}

//-------------END Scroll To Top Element-------------------


document.addEventListener('DOMContentLoaded', (e) => {
  addToCartFromProductItem();
  scrollToTop();
});

document.addEventListener('collection:load-products', (e) => {
  addToCartFromProductItem();
});

document.addEventListener('recommendations:loaded', (e) => {
  addToCartFromProductItem();
});
